import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CustomerCaptainPickerComponent } from './customer-captain-picker.component';
import { CustomerCaptain } from 'anchor-shared/lib/model/interface/customerInterfaces';

@Injectable({
  providedIn: 'root',
})
export class CustomerCaptainPickerService {
  constructor(private dialog: MatDialog) {}

  public open(
    captains: CustomerCaptain[],
    charterId: number,
    primaryCaptainId: number,
  ): Observable<CustomerCaptain> {
    let dialogRef: MatDialogRef<CustomerCaptainPickerComponent>;
    dialogRef = this.dialog.open(CustomerCaptainPickerComponent, {
      maxWidth: '95vw',
      maxHeight: '80vh',
      data: {
        captains: captains,
        charterId: charterId,
        primaryCaptainId: primaryCaptainId,
      },
    });
    return dialogRef.afterClosed();
  }
}
